export default {
    'add-category': 'Add category',
    'edit-category': 'Edit category',
    'the-category': 'the category?'
}